import React, { useState } from 'react';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { useDispatch } from 'react-redux';
import { push } from 'redux-first-history';
import { useStateValidator } from 'react-use';
import { Auth } from 'aws-amplify';
import get from 'lodash/get';

import { toastr } from 'react-redux-toastr';
import isEmail from 'validator/es/lib/isEmail';

import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

export default function ForgotPasswordForm() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [emailValid] = useStateValidator(email, (email) => isEmail(email));
  const [emailErrorText, setEmailErrorText] = useState(null);

  const handleNavigate = (path) => {
    dispatch(push(path));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!emailValid) {
      setEmailErrorText('Invalid email');
      toastr.error('Email address Invalid');
    } else {
      try {
        dispatch(showLoading());
        await Auth.forgotPassword(email);

        toastr.success('Password change instructions sent via email');
        dispatch(push('/auth'));
      } catch (error) {
        console.error(error);
        if (get(error, 'code') === 'InvalidParameterException') {
          await Auth.resendSignUp(email);
          toastr.success('Verification link sent to your email');
          dispatch(push('/auth'));
        } else {
          toastr.error('Error', error.message ? error.message : error);
        }
      } finally {
        dispatch(hideLoading());
      }
    }
  };

  return (
    <>
      <Typography variant='h4'>Forgot Password</Typography>
      <List disablePadding>
        <form>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <TextField
              id='email'
              error={!!emailErrorText}
              label='Email'
              placeholder='Enter email'
              fullWidth
              onChange={(e) => setEmail(e.target.value)}
              variant='standard'
              helperText={emailErrorText}
            />
          </ListItem>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              fullWidth
              onClick={handleSubmit}>
              Submit
            </Button>
          </ListItem>
        </form>
      </List>
      <Link
        color='inherit'
        underline='hover'
        variant='body1'
        sx={{ cursor: 'pointer' }}
        onClick={() => handleNavigate('/auth')}>
        Back to Login
      </Link>
    </>
  );
}
